import React, { useEffect } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import ReactPlayer from 'react-player'

export default props => {
    useStyles(classes)
    const { video, endedHandle, shouldPlay, clickHandle } = props
    const [playing, setPlaying] = React.useState(!!shouldPlay)
    const onEnded = () => {
        endedHandle()
    }

    useEffect(() => {
        setPlaying(!!shouldPlay)
    }, [shouldPlay])


    return <div className={classes.SimpleVideo} onClick={clickHandle}>
        <ReactPlayer
            className={classes.Player}
            width='100%'
            height='100%'
            url={`https://www.youtube.com/watch?v=${video.youtubeId}`}
            muted
            playing={playing}
            config={{
                youtube: {
                    playerVars: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy: 3 },
                    embedOptions: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy: 3 }
                }
            }}
            onEnded={onEnded}
        />
    </div>
}